export default {
  mobile_app_average_order_value: {
    label: 'GBW via app',
  },
  mobile_app_gmv: {
    label: 'App-omzet',
  },
  mobile_app_gmv_percentage: {
    label: 'Omzet % via app',
  },
  mobile_app_downloads: {
    label: 'Downloads',
  },
  mobile_app_orders_count: {
    label: 'App-bestellingen',
  },
  name: {
    label: 'Restaurant',
  },
  mobile_app_released_at: {
    label: 'Lanceringsdatum',
  },
  title: 'Restaurantoverzicht',
};
